import React from "react";
import img from "../../assets/images/edu_img_1.jpg";
import mission from "../../assets/icons/mission-01.png";
const HomeMission = () => {
  return (
    <div className=" py-20 relative" id="our-mission">
      <div className=" md:top-5 bottom-0 absolute left-2 z-0 ">
        <img
          src={mission}
          alt="about our education "
          className="lg:w-80 w-48"
        />
      </div>
      <div className="xl:max-w-screen-xl w-11/12 mx-auto flex flex-col justify-center items-center z-[2]">
        <p className="font-teacher text-base sm:pb-3 pb-0 text-[#005064] font-bold tracking-[4px] uppercase">
          Our mission
        </p>
        <h2
          className="xl:text-5xl sm:text-4xl text-3xl font-semibold text-center py-4 text-[#1a1a1a]"
          style={{
            lineHeight: "1.2em",
          }}
        >
          A Vision Beyond Learning
        </h2>

        <div className="md:mt-16 mt-10 grid lg:grid-cols-2 xl:gap-8 gap-4 w-full z-[5]">
          <div className="flex justify-center items-center">
            <img src={img} alt="" className="rounded-xl" />
          </div>
          <div>
            <p className="text-base text-[#1a1a1a] pt-5">
              These days many schools Over-Emphasize Standardized Compliance,
              memorize-and-forget Curriculum & High-Stakes pressure which fuels
              an Epidemic of anxiety. We want to replace these rigid silos with
              interconnected learning, active creation and relational
              mentorship.
            </p>

            <p className="text-base text-[#1a1a1a]  sm:py-5 py-3">
              SLN Educational Society is a group of educational institutions
              which focus on future-needed skills for the generations to come.
              Our pioneer K-12 international school project is built with a
              belief that compassion & character are the cornerstones from where
              everything else grows.
            </p>
            <p className="text-base text-[#1a1a1a] ">
              At SLN Educational institutions, students will learn to attain
              global connection and expression. Where learning is driven by
              wonder rather than the anxiety of assessments, and where every
              child feels seen for who they are, not just how they perform.
            </p>
            <p className="text-base text-[#1a1a1a]  sm:pt-5 pt-3">
              On success of our vision we could see a shift from a culture of
              hyper competition to one of deep collaboration. Communities can
              see an influx of young generation who don't just ask, "How do I
              move ahead " but, "How do we raise together ?". Civic spaces
              revitalized by a generation that solves complex, messy problems
              with empathy & creativity
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeMission;
